import React from "react";
import PropTypes from "prop-types";
import { Select, Functions } from "rhombus-react";

import { noop } from "utils/common";
import EmptySection from "widgets/EmptySection";

import { TARGET_METHODS } from "utils/constants";

import AutoOptimizationModel from "./AutoOptimizationModel";

import "./AutoOptimizationPanel.css";

const OPTIMIZATION_MODELS = [
	{ value: TARGET_METHODS.MODERN, label: "Modern" },
	{ value: TARGET_METHODS.SOFTMAX, label: "New Modern" },
	{ value: TARGET_METHODS.STATISTICAL_SIGNIFICANCE, label: "Statistical Significance" },
	{ value: TARGET_METHODS.LEGACY, label: "Legacy" },
];

export default function AutoOptimizationPanel(props){
	let {
			isSelected,
			currentValue,
			onChange,
			isModernEnabled,
		} = props
		, $optionsList = null
		;

	if(!isSelected){
		return <EmptySection className="choose-existing" icon="autoOptimization" header="Auto-Optimization" />;
	}

	if(isModernEnabled){
		const selectorValue = currentValue === TARGET_METHODS.MODERN_AUDIENCE ? TARGET_METHODS.MODERN : currentValue;

		const selectedOption = OPTIMIZATION_MODELS.find(opt => opt.value === selectorValue);

		$optionsList = (
			<Select
				label="Optimization Model"
				options={OPTIMIZATION_MODELS}
				value={selectedOption}
				onChange={val => onChange(val.value)}
				isClearable={false}
				onMenuScrollToBottom={Functions.noop}
			/>
		);
	}

	return (
		<div className="multi-type">
			<h2>Auto-Optimization</h2>
			<aside className="type-selection">
				{$optionsList}
			</aside>
			<AutoOptimizationModel {...props} />
		</div>
	);
}


AutoOptimizationPanel.displayName = "AutoOptimizationPanel";
AutoOptimizationPanel.propTypes = {
	isSelected: PropTypes.bool,
	currentValue: PropTypes.string,
	onChange: PropTypes.func,
	isModernEnabled:PropTypes.bool,
	onObjective: PropTypes.func,
};

AutoOptimizationPanel.defaultProps = {
	isSelected: false,
	currentValue: null,
	onChange: noop,
	isModernEnabled:false,
};
